import { defineMessages } from "react-intl";

export default defineMessages({
  btnSubmit: {
    id: "Auth.AuthCheckUserForm.btnSubmit",
    defaultMessage: "Submit",
  },
});
